import React from 'react';
import { Badge } from '@mui/material';

import { TabBarSurveysIcon } from '@ocx/ui-icons';

export interface ISurveysTabBarIconWithBadgeProps {
  totalCount: number;
}

export const SurveysTabBarIconWithBadge = ({ totalCount }: ISurveysTabBarIconWithBadgeProps) => {
  return (
    <Badge badgeContent={totalCount} color="error">
      <TabBarSurveysIcon />
    </Badge>
  );
};
